import React from "react";

interface IProps {
    onClose?(): void;
}

export default class ServerErrorModal extends React.Component<IProps> {
    public render(): JSX.Element {
        const { onClose } = this.props;
        return (
            <div className="modal is-active">
                <div
                    className="modal-background"
                    onClick={ onClose }
                ></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <div className="modal-card-title">Game Unavailable</div>
                        { onClose ? (
                            <button className="delete" aria-label="close"></button>
                        ) : undefined }
                    </header>
                    <section className="modal-card-body">
                        <p>The game is currently unavailable.</p>
                        <p>Please try again in a moment.</p>
                    </section>
                    <footer className="modal-card-foot">
                    { onClose ? (
                        <button
                            className="button"
                            onClick={ onClose }
                        >Close</button>
                    ) : (
                        <button
                            className="button"
                            onClick={ this.refresh.bind(this) }
                        >Refresh</button>
                    ) }
                    </footer>
                </div>
            </div>
        );
    }

    protected refresh(): void {
        const FORCE_RELOAD = true;
        document.location.reload(FORCE_RELOAD);
    }
}



// WEBPACK FOOTER //
// ./src/components/ServerErrorModal.tsx